export default __webpack_public_path__ + "locales/vi/Webhooks.json?hash=0f7641a45b32c011f416da7baa5be406";